import { render, staticRenderFns } from "./error-24.vue?vue&type=template&id=6cc3aa03&scoped=true"
import script from "./error-24.vue?vue&type=script&lang=js"
export * from "./error-24.vue?vue&type=script&lang=js"
import style0 from "./error-24.vue?vue&type=style&index=0&id=6cc3aa03&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc3aa03",
  null
  
)

export default component.exports